import classNames from 'classnames';
import React from 'react';
import { ChildrenPropType } from 'src/utils/types';

type Props = {
  children: ChildrenPropType;

  textCenter?: boolean;
  className?: string;
  hoverable?: boolean;
  id?: string;
};

export const UiCard: React.FC<Props> = ({ children, textCenter = false, className, hoverable = true, id }) => (
  <div
    id={id}
    className={classNames('card', className, {
      'text-center': textCenter,
      hoverable,
    })}
  >
    <div className="card-content">{children}</div>
  </div>
);
